module.exports = __webpack_public_path__ + "static/media/pic1.cf1ba5c9.jpg";